<div
    class="container"
    *ngrxLet="{
        isCookiesInfoAvailable: isCookiesInfoAvailable$,
        isProjectsFundingLinkAvailable: isProjectsFundingLinkAvailable$,
        shouldOpenProjectsFundingLinkInNewTab: shouldOpenProjectsFundingLinkInNewTab$
    } as vm"
>
    <img class="pansa-logo" src="assets/images/pansa.svg" alt="" height="24" />

    <div class="links">
        <a
            *ngIf="vm.isProjectsFundingLinkAvailable"
            [href]="projectsFundingUrl"
            rel="noopener noreferrer"
            [target]="vm.shouldOpenProjectsFundingLinkInNewTab ? '_blank' : '_self'"
        >
            {{ "dtmUi.footer.projectsLabel" | transloco }}
        </a>
        <a [href]="termsOfUseUrl" rel="noopener noreferrer" target="_blank">
            {{ "dtmUi.footer.termsOfUseLabel" | transloco }}
        </a>
        <a [href]="accessibilityStatementUrl" rel="noopener noreferrer" target="_blank">
            {{ "dtmUi.footer.accessibilityStatementLabel" | transloco }}
        </a>
        <button
            *ngIf="vm.isCookiesInfoAvailable"
            type="button"
            (click)="cookiesInfoSelect.emit()"
            (keydown.enter)="cookiesInfoSelect.emit()"
        >
            {{ "dtmUi.footer.cookiesInfoLabel" | transloco }}
        </button>
        <a [href]="HELP_CENTER_URL" target="_blank">
            {{ "dtmUi.footer.helpCenterLabel" | transloco }}
        </a>
        <a [href]="PANSA_FACEBOOK_URL" rel="noopener noreferrer" target="_blank">
            <dtm-ui-icon name="facebook" />
            {{ "dtmUi.footer.facebookLabel" | transloco }}
        </a>
        <a [href]="PANSA_WHATSAPP_URL" rel="noopener noreferrer" target="_blank">
            <dtm-ui-icon name="whatsapp" />
            {{ "dtmUi.footer.whatsappLabel" | transloco }}
        </a>
    </div>
</div>
